// NOTE: This is not a complete list of all tags, but currently we use only the following
export enum TagType {
    INTIMATE_BUILDING = 14,
    GREEN_AREAS = 44,
    SPECIAL_PRICE = 43
}
// NOTE: This is not a complete list of all tags, but currently we use only the following
export enum TagType {
    INTIMATE_BUILDING = 14,
    GREEN_AREAS = 44,
    SPECIAL_PRICE = 43
}
